<!--基础组件-->
<template>
    <!-- 不阻止粘贴事件 onpaste="return false" -->
  <div
    :class="{
      'widgets-wrap': true,
      maxTop: isFocus || !!cachetMove || showSetting,
      move: !!cachetMove,
      fixed: !!itemInfo.chapteFixed
    }"
    :style="[handleSetChapte,styleIconVar]"
    ref="move-box"
    :key="loopkey"
    @click.capture="$emit('click', itemInfo)"
    tabindex="0"
  >
    <!--    正常组件，可以编辑设置变量信息-->
    <template v-if="!itemInfo.chapteFixed">
      <div class="input-wrap">
        <span
          class="icon-drag"
          @mousedown.capture="handleCacheMousedown($event)"
        ></span>
        <span class="el-icon-error delco" @click="delItemInfo"></span>

        <!--        多行文本-->
        <template v-if="itemInfo.varType === flag.MULTITEXT">
          <el-input
            ref="inputbox"
            type="textarea"
            :value="itemInfo.varName"
            :readonly="itemInfo.copy"
            @input="changeVarName"
            :placeholder="getFlagInfo.text + (parseInt(loopkey) + 1)"
            @focus="handleVartable(true)"
            @blur="isFocus = false"
            maxlength="20"
            :style="SetWh"
            :class="[['', 'text_align_center', 'text_align_right'][Number(itemInfo.align)], {'copy-sty-input':itemInfo.copy, 'font_bold': itemInfo.bold}]"
            resize="none"
            autosize
          />
          <!--      伸缩点位-->
          <template v-if="isFocus">
            <span
              class="tl"
              @mousedown.prevent="sfMousedownHanlder($event, 'tl')"
              ><!-- 左上侧点--></span
            >
            <span
              class="bl"
              @mousedown.prevent="sfMousedownHanlder($event, 'bl')"
              ><!-- 左下侧点--></span
            >
            <span
              class="tr"
              @mousedown.prevent="sfMousedownHanlder($event, 'tr')"
              ><!-- 右上侧点--></span
            >
            <span class="r" @mousedown.prevent="sfMousedownHanlder($event, 'r')"
              ><!-- 右侧点--></span
            >
            <span
              class="br"
              @mousedown.prevent="sfMousedownHanlder($event, 'br')"
              ><!-- 右下侧点--></span
            >
          </template>
        </template>
        <!-- 单选 -->
        <div v-else-if="itemInfo.varType === flag.RADIO" @click="handleVartable(true)">
          <el-radio-group v-model="radioCheck" ref="inputbox"  class="check-sty" :class="{'copy-sty':itemInfo.copy}" :style="SetWh">
            <p v-for="(vv,i) of optionList" :key="i" :style="{'text-align': ['left', 'center', 'right'][Number(itemInfo.align)]}">
              <el-radio :label="vv.key" class="check-icon">
                <span
                  :style="{
                    'font-size':`${itemInfo.fontSize}px`,
                    'line-height':`${checkLineHeight}`,
                     'font-weight': itemInfo.bold ? 'bold' : '',
                  }"
                >
                  {{vv.val || vv.placeholder}}
                </span>
                <!-- <span :style="{display:'inline-block',width:`${itemInfo.fontSize}px`}"> </span> -->
              </el-radio>
            </p>
            <!--      伸缩点位-->
            <template v-if="isFocus">
              <span
                class="tl"
                @mousedown.prevent="sfMousedownHanlder($event, 'tl')"
                ><!-- 左上侧点--></span
              >
              <span
                class="bl"
                @mousedown.prevent="sfMousedownHanlder($event, 'bl')"
                ><!-- 左下侧点--></span
              >
              <span
                class="tr"
                @mousedown.prevent="sfMousedownHanlder($event, 'tr')"
                ><!-- 右上侧点--></span
              >
              <span class="r" @mousedown.prevent="sfMousedownHanlder($event, 'r')"
                ><!-- 右侧点--></span
              >
              <span
                class="br"
                @mousedown.prevent="sfMousedownHanlder($event, 'br')"
                ><!-- 右下侧点--></span
              >
            </template>
          </el-radio-group>
        </div>
        <!-- 多选 -->
        <div v-else-if="itemInfo.varType === flag.MULTIPLE" @click="handleVartable(true)">
          <el-checkbox-group v-model="checkList" ref="inputbox" class="check-sty" :style="SetWh" :class="{'copy-sty':itemInfo.copy}">
            <p v-for="(vv,i) of optionList" :key="i" :style="{'text-align': ['left', 'center', 'right'][Number(itemInfo.align)]}">
              <el-checkbox :label="vv.key" class="check-icon">
                <span
                  :style="{
                    'font-size':`${itemInfo.fontSize}px`,
                    'line-height':`${checkLineHeight}`,
                    'font-weight': itemInfo.bold ? 'bold' : '',
                  }"
                >
                  {{vv.val || vv.placeholder}}
                </span>
              </el-checkbox>
            </p>
            <!--      伸缩点位-->
            <template v-if="isFocus">
              <span
                class="tl"
                @mousedown.prevent="sfMousedownHanlder($event, 'tl')"
                ><!-- 左上侧点--></span
              >
              <span
                class="bl"
                @mousedown.prevent="sfMousedownHanlder($event, 'bl')"
                ><!-- 左下侧点--></span
              >
              <span
                class="tr"
                @mousedown.prevent="sfMousedownHanlder($event, 'tr')"
                ><!-- 右上侧点--></span
              >
              <span class="r" @mousedown.prevent="sfMousedownHanlder($event, 'r')"
                ><!-- 右侧点--></span
              >
              <span
                class="br"
                @mousedown.prevent="sfMousedownHanlder($event, 'br')"
                ><!-- 右下侧点--></span
              >
            </template>
          </el-checkbox-group>
        </div>
        <!--        其他-->
        <template v-else>
          <el-input
            ref="inputbox"
            type="text"
            :value="itemInfo.varName"
            @input="changeVarName"
            :placeholder="getFlagInfo.text + order"
            @focus="handleVartable(true)"
            @blur="isFocus = false"
            maxlength="20"
            :style="SetWh"
            :class="[['', 'text_align_center', 'text_align_right'][Number(itemInfo.align)], {'copy-sty-input':itemInfo.copy, 'font_bold': itemInfo.bold}]"
            :readonly="!getFlagInfo.isFormat || itemInfo.copy"
          />
          <!--      伸缩点位-->
          <template v-if="isFocus">
            <span class="r" @mousedown.prevent="sfMousedownHanlder($event, 'r')"
              ><!-- 右侧点--></span
            >
          </template>
        </template>
        <!-- <p class="let-name">{{showName(itemInfo) ? itemInfo.varName : itemInfo.inputId}}</p> -->
      </div>
      <!--      编辑窗口-->
      <div
        class="set-wrap"
        v-if="showSetting"
        :style="settingStyle()"
        ref="settingBox"
      >
        <!-- {{ getFlagInfo.title }} -->
        <h1>
          设置变量<span
            class="el-icon-error"
            @click="changeShowSetting(false)"
          ></span>
        </h1>
        <div class="con">
          <!-- 【1526】加入变量名称 -->
          <p class="var-setting">变量名称</p>
          <el-input
            :value="itemInfo.inputId"
            @input="changeInputId"
            placeholder="填写变量名称"
            :disabled="itemInfo.copy"
            maxlength="20"
            type="text"
            resize="none"
            :row="2"
          />
          <!-- 1197需求 加入变量类型 -->
          <p class="var-setting">变量类型</p>
          <template>
            <el-select v-model="itemInfo.varType" placeholder="请选择变量类型" :disabled="itemInfo.copy" @change="changeVarType">
              <el-option
                v-for="item in flagType.flagOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
<!--          系统日期-->
          <template v-if="itemInfo.varType === flag.SYSTEMDATE">
            <p class="var-setting">日期格式</p>
<!--            @change="changeVarType"-->
            <el-select v-model="itemInfo.formatStyle" placeholder="请选择日期格式" :disabled="itemInfo.copy" >
              <el-option
                v-for="item in flagType.systemDateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <p class="var-setting">对应签章</p>
            <el-select v-model="itemInfo.signerAbc" placeholder="请选择签章" :disabled="itemInfo.copy" >
              <template  v-for="(signerItem, signerIndex) in signerList">
                <el-option
                  v-if="signerItem.fix == 0"
                  :key="signerIndex"
                  :label="signerItem.signerAbc"
                  :value="signerItem.signerAbc"
                >
                </el-option>
                <el-option
                  v-else
                  :key="signerIndex"
                  :label="signerItem.name"
                  :value="signerItem.signerAbc"
                >
                </el-option>
              </template>

            </el-select>
          </template>
          <template v-if="getFlagInfo.isFormat && (itemInfo.varType !== flag.RADIO && itemInfo.varType !== flag.MULTIPLE && itemInfo.varType !== flag.SYSTEMDATE)">
            <p class="var-setting">提示文字</p>
            <!--        多行文本-->
            <template v-if="itemInfo.varType === flag.MULTITEXT">
              <el-input
                :class="[['', 'text_align_center', 'text_align_right'][Number(itemInfo.align)], {'font_bold': itemInfo.bold}]"
                :value="itemInfo.varName"
                @input="changeVarName"
                :placeholder="getFlagInfo.text + order"
                maxlength="20"
                :type="getFlagInfo.type"
                resize="none"
                :row="2"
                :disabled="itemInfo.copy"
              />
            </template>
            <template v-else>
              <el-input
                :class="[['', 'text_align_center', 'text_align_right'][Number(itemInfo.align)], {'font_bold': itemInfo.bold}]"
                :value="itemInfo.varName"
                @input="changeVarName"
                :placeholder="getFlagInfo.text"
                :type="getFlagInfo.type"
                maxlength="20"
                :disabled="itemInfo.copy"
              />
            </template>
          </template>
          <!-- 设置选项（单选多选） -->
          <template v-if="itemInfo.varType === flag.RADIO || itemInfo.varType === flag.MULTIPLE">
            <p class="var-setting between">
              <span>选项设置</span>
              <i class="el-icon-circle-plus-outline action-sty" v-show="!itemInfo.copy" @click="addOption"></i>
            </p>
            <p v-for="(vv,i) of optionList" :key="vv.key" class="option-item">
              <i class="el-icon-s-operation"></i>
              <el-input
                type="text"
                v-model="vv.val"
                :placeholder="vv.placeholder"
                :disabled="itemInfo.copy"
                :maxlength="20"
                style="margin: 0 5px;"
                clearable
              />
              <i class="el-icon-delete action-sty" v-show="!itemInfo.copy" @click="removeOption(i)"></i>
            </p>
          </template>

          <p class="var-setting">字号</p>
          <el-select
            :value="itemInfo.fontSize"
            placeholder="请选择"
            :disabled="itemInfo.copy"
            @change="changeFontSize"
          >
            <el-option
              v-for="item in fontOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div style="margin-top: 15px;">
            <el-checkbox
              :value="itemInfo.varIsMust"
              :disabled="itemInfo.copy"
              @change="
                val => {
                  $emit('changeItemInfo', { ...this.itemInfo, varIsMust: val });
                }
              "
              >必填
            </el-checkbox>
            <el-checkbox
              :value="itemInfo.bold"
              :true-label="1"
              false-label=""
              :disabled="itemInfo.copy"
              @change="
                val => {
                  $emit('changeItemInfo', { ...this.itemInfo, bold: val });
                }
              "
            >加粗
            </el-checkbox>
            <el-radio-group style="margin-top: 10px" v-model="itemInfo.align">
              <el-radio label="">左对齐</el-radio>
              <el-radio :label="1">居中</el-radio>
              <br>
              <el-radio :label="2">右对齐</el-radio>
            </el-radio-group>
          </div>
          <p v-if="getFlagInfo.isFormat && itemInfo.varType !== flag.SYSTEMDATE" style="margin-top: 15px;">
            可输入字数：{{ itemInfo.fontMaxNum }}
          </p>
        </div>
        <p class="btns-sty" v-show="!itemInfo.copy">
          <a class="btn" @click="copyShowSetting">复制</a>
          <a class="btn" @click="changeShowSetting(false)">确定</a>
        </p>
      </div>
    </template>

    <!--  固定组件，不可移动，不可删除，不显示设置弹窗，不可更改宽高，可以更改值-->
    <div class="fixedWt" v-else>
      <!--  多行文本-->
<!--      :style="{...SetWh, 'text-align': ['left', 'center', 'right'][Number(itemInfo.align)], 'font-weight': itemInfo.bold ? 'bold' : ''}"-->
      <template v-if="itemInfo.varType === flag.MULTITEXT">
        <el-input
          type="textarea"
          :style="SetWh"
          :class="[['', 'text_align_center', 'text_align_right'][Number(itemInfo.align)],{ 'font_bold': itemInfo.bold, outstanding: !!itemInfo.selected,'copy-sty-input':itemInfo.copy }]"
          :value="itemInfo.value"
          :readonly="itemInfo.copy"
          :maxlength="itemInfo.fontMaxNum"
          :placeholder="itemInfo.varName || getFlagOption.title"
          @input="changeValue"
          resize="none"
        />
      </template>
      <!--  日期-->
      <template v-else-if="itemInfo.varType === flag.DATE">
        <el-date-picker
          :class="[['', 'text_align_center', 'text_align_right'][Number(itemInfo.align)], {outstanding: !!itemInfo.selected,'copy-sty-input':itemInfo.copy, 'font_bold': itemInfo.bold}]"
          type="date"
          align="left"
          value-format="yyyy-MM-dd"
          :style="SetWh"
          :value="itemInfo.value"
          :editable="false"
          :disabled="itemInfo.copy"
          :placeholder="itemInfo.varName || getFlagOption.title"
          @input="changeValue"
        />
      </template>
      <!-- 单选 -->
      <template v-else-if="itemInfo.varType === flag.RADIO">
        <el-radio-group
          :value="itemInfo.value"
          @input="changeValue"
          :disabled="itemInfo.copy"
          class="check-sty"
          :class="{'copy-sty':itemInfo.copy}"
          :style="SetWh"
        >
          <div v-for="(vv,i) of optionList" :key="i" class="item-check" :style="{'text-align': ['left', 'center', 'right'][Number(itemInfo.align)]}">
            <el-radio :label="vv.val" class="check-icon">
              <span
                  :style="{
                    'font-size':`${itemInfo.fontSize}px`,
                    'line-height':`${checkLineHeight}`,
                    'font-weight': itemInfo.bold ? 'bold' : '',
                  }"
                >
                  {{vv.val || vv.placeholder}}
                </span>
            </el-radio>
          </div>
        </el-radio-group>
      </template>
      <!-- 多选 -->
      <template v-else-if="itemInfo.varType === flag.MULTIPLE">
        <el-checkbox-group :value="itemInfo.value" @change="changeValue" :disabled="itemInfo.copy"  class="check-sty" :class="{'copy-sty':itemInfo.copy}" :style="SetWh">
          <div v-for="(vv,i) of optionList" :key="i" class="item-check" :style="{'text-align': ['left', 'center', 'right'][Number(itemInfo.align)]}">
            <el-checkbox :label="vv.val" class="check-icon">
              <span
                :style="{
                  'font-size':`${itemInfo.fontSize}px`,
                  'line-height':`${checkLineHeight}`,
                  'font-weight': itemInfo.bold ? 'bold' : '',
                }"
              >
                {{vv.val || vv.placeholder}}
              </span>
            </el-checkbox>
          </div>
        </el-checkbox-group>
      </template>

      <!--  其他-->
      <template v-else>
        <el-input
          :class="[['', 'text_align_center', 'text_align_right'][Number(itemInfo.align)], {outstanding: !!itemInfo.selected,'copy-sty-input':itemInfo.copy , 'font_bold': itemInfo.bold}]"
          type="text"
          :style="SetWh"
          :value="itemInfo.value"
          :readonly="itemInfo.copy || Number(itemInfo.varType) === Number(flag.SYSTEMDATE)"
          :placeholder="itemInfo.varName || getFlagOption.title"
          :maxlength="itemInfo.fontMaxNum"
          @input="changeValue"
        />
      </template>
    </div>
  </div>
</template>
<script>
import flagType from "./flagType";
import {mapGetters} from "vuex";

export default {
  name: "widgets",
  props: {
    // 循环时的key
    loopkey: {
      type: [String, Number],
      default: ""
    },
    itemInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    // 定位的父级容器id
    relativeNodeId: {
      type: String,
      default: ""
    },
    // 缩放比例
    scaleValue: { type: Number, default: 100 }
  },
  data() {
    return {
      // 单多选设置行高。撑起容器避免多行重叠
      checkLineHeight:1.5,
      checkList:[],
      radioCheck:'',
      optionList:[],
      order: parseInt(this.loopkey) + 1,
      flagType,
      flag: flagType.flag,
      cachetMove: false,
      // 当前用户选中拖拽的章的dom对象
      objCurrentCachet: null,
      fontOptions: flagType.getFontMap(),
      showSetting: false,
      // 伸缩点相关
      isFocus: false
    };
  },
  created(){
    const _VBool = (this.itemInfo.varType === this.flag.MULTIPLE) || (this.itemInfo.varType === this.flag.RADIO),{id:isEdit} = this.$route.query
    if(_VBool && !this.itemInfo.copy && this.optionList.length === 0){
      this.addOption()
      if(isEdit) this.turnOptions()
    }
  },
  computed: {
    // 获取store里面的数据
    ...mapGetters("advancedVersionState", {
      GET_addTpl_contractInfoJson: "GET_addTpl_contractInfoJson"
    }),
    signerList(){
      return this.GET_addTpl_contractInfoJson.signers ? this.GET_addTpl_contractInfoJson.signers : []
    },
    // 计算当前章在页面中的位置
    handleSetChapte() {
      let {
        realWidth: parentWidth,
        realHeight: ParentHeight
      } = this.getParentInfo();
      let { offsetX, offsetY } = this.itemInfo; // 根据组件在合同中左下角位置比例信息换算出left ，top值
      let caechetH = this.itemInfo.h * ParentHeight;
      return {
        left: parseFloat((offsetX * parentWidth).toFixed(4)) + "px",
        top: parseFloat((offsetY * ParentHeight - caechetH).toFixed(4)) + "px" // 保存的时左下角的点位置，显示时计算top值需要减去本身高度
      };
    },
    // 根据组件类型返回对应信息
    getFlagInfo() {
      // 这里都不做校验，只在使用模板时控制
      switch (this.itemInfo.varType) {
        case this.flag.MULTITEXT:
          return {
            title: "文本框",
            // text: "文本框",
            text: "变量",
            type: "textarea",
            isFormat: true // 显示提示文字和可输入字数,并且可以编辑
          };
        case this.flag.TEXT:
          return {
            title: "单行文本框",
            // text: "单行文本框",
            text: "变量",
            type: "text",
            isFormat: true
          };
        case this.flag.NUMBER:
          return {
            title: "数字框",
            text: "数字框",
            type: "text",
            isFormat: true
          };
        case this.flag.DATE:
          return {
            title: "日期",
            text: "20XX-08-08（日期）",
            type: "text",
            isFormat: true // 显示提示文字和可输入字数,并且可以编辑
          };
        case this.flag.PHONE:
          return {
            title: "手机号码",
            text: "188XXXXX888（手机号）",
            type: "text"
          };
        case this.flag.IDCARD:
          return {
            title: "身份证号码",
            text: "500XXXXXXXXXXXX53X（身份证号）",
            type: "text"
          };
        case this.flag.LICENCENO:
          return {
            title: "营业执照号",
            text: "9150XXXXXXXXXXXP30",
            type: "text"
          };
        case this.flag.SOCIALCODE:
          return {
            title: "统一社会信用代码",
            text: "9150XXXXXXXXXXXP30（统一社会信用代码）",
            type: "text"
          };
        case this.flag.EMAIL:
          return {
            title: "电子邮箱",
            text: "XXXX@XX.com（电子邮箱）",
            type: "text",
            isFormat: true
          };
        case this.flag.SYSTEMDATE:
          return {
            title: "系统日期",
            text: "系统日期",
            type: "select",
            isFormat: true
          };
        // 默认单行文本框
        default:
          return {
            title: "单行文本框",
            // text: "单行文本框",
            text: "变量",
            type: "text",
            isFormat: true
          };

      }
    },
    // 根据组件类型返回对应信息
    getFlagOption() {
      return this.flagType.getFlagOption(this.itemInfo.varType);
      // return `变量${this.loopkey}`;
    },
    /** 重新计算 可输入input 框大小 */
    SetWh() {
      let {
        realWidth: parentWidth,
        realHeight: ParentHeight
      } = this.getParentInfo();
      return {
        ...this.flagType.getWHbyFont(this.itemInfo),
        // 使用设置的w，h计算宽高
        width: this.itemInfo.w * parentWidth + "px",
        height: this.itemInfo.h * ParentHeight + "px",
        "font-weight": 'bold',
      };
    },
    styleIconVar() {
      return {
        '--icon-size': this.itemInfo.fontSize + 'px'
      }
    }
  },
  mounted() {
    // console.log(this.getParentInfo());
    this.showSetting = this.itemInfo.showSetting; // 页面加载完成才显示设置窗口，渲染逻辑依赖input 输入框dom
  },
  methods: {
    /** 点击变量 */
    handleVartable(Bool){
      if(this.itemInfo.copy) return false
      this.changeShowSetting(Bool)
      this.isFocus = true
    },
    /** 兼容变量名称老数据 */
    showName(item){
      const reg = /[0-9A-Z]{32}/g;
      return reg.test(item.inputId)
    },
    /** 删除选项 */
    removeOption(index){
      if(this.itemInfo.copy) return false
      const len = this.optionList.length;
      if(len === 1) return this.$message.warning('至少有一个选项')
      this.optionList.splice(index,1)
      this.$nextTick(()=>{
        this.optionList.forEach((item,i) => {
          this.$set(this.optionList,i,{key:item.key,val:item.val,placeholder:`选项${i+1}`})
          this.changechoce(this.optionList)
        });
      })

    },
    /** 添加选项 */
    addOption(){
      if(this.itemInfo.copy) return false
      const len = this.optionList.length,key=new Date().getTime()
      if(len === 10) return this.$message.warning('仅支持 10 个选项')
      this.optionList.push({key,val:`选项${len+1}`,placeholder:`选项${len+1}`})
      this.itemInfo.defineValue = this.optionList
      this.changechoce(this.optionList)
    },
    /** 回显选项 */
    turnOptions(){
      if(this.itemInfo.varType === this.flag.RADIO || this.itemInfo.varType === this.flag.MULTIPLE){
        const {defineValue}=this.itemInfo
        this.optionList = Array.from(defineValue ? defineValue : [])
      }
    },
    // 计算设置弹窗位置-边界情况重新偏移-向右向左向下向上
    settingStyle() {
      let settingBox = this.$refs["settingBox"];

      let settingWidth = this.scaleToVal(
        settingBox ? settingBox.clientWidth + 8 : 195
      );
      let settingHeight = this.scaleToVal(
        settingBox ? settingBox.clientHeight + 8 : 285
      );
      // 当前输入框右侧距离合同距离
      let {
        width: contractWidth,
        height: contractHeight,
        x: contractX,
        y: contractY
      } = this.getParentInfo();
      let {
        scaleWidth: inputWidth,
        scaleHeight: inputHeight,
        x: inputX,
        y: inputY,
        width,
        height
      } = this.getCurrentInfo();
      inputWidth = parseInt(inputWidth);
      inputHeight = parseInt(inputHeight);
      let bj = this.scaleToVal(35);

      let surplusRight = contractWidth - (inputX - contractX) - inputWidth - bj; // 剩余右侧距离合同边值
      let surplusLeft = inputX - contractX - bj; // 剩余左侧距离合同边值
      let surplusBottom =
        contractHeight - (inputY - contractY) - inputHeight - bj; // 剩余底部距离合同边值
      let surplusTop = inputY - contractY - bj; // 剩余顶部距离合同边值

      let horizontal = {}; // 横向处理
      if (surplusRight >= settingWidth) {
        // 右侧距离足够展示
        horizontal = {
          right: -1 * this.scaleToShow(settingWidth) + "px"
        };
      } else {
        horizontal = {
          left: -1 * this.scaleToShow(settingWidth) + "px"
        };
      }

      let vertical = {}; // 纵向向处理
      if (surplusBottom >= settingHeight) {
        vertical = {
          top: 0
        };
      } else {
        vertical = {
          top: -1 * this.scaleToShow(settingHeight) + "px"
        };
      }

      if (surplusRight < settingWidth && surplusLeft < settingWidth) {
        // 左右两边都不够显示，则上下显示
        horizontal = {
          left: 0
        };
        if (surplusBottom >= settingHeight) {
          // 下面距离足够
          vertical = {
            bottom: -1 * this.scaleToShow(settingHeight) + "px"
            // bottom: settingBox ? -1 * (settingBox.clientHeight) + 'px' : 'initial',
            // bottom: 'initial',
          };
        } else {
          vertical = {
            top: -1 * this.scaleToShow(settingHeight) + "px"
          };
        }
      }

      return {
        ...horizontal,
        ...vertical
      };
    },
    // 相对父级定位-获取定位父级（设置position:relative;的父级）信息
    getParentInfo() {
      // let parentNode = this.$el ? this.$el.parentNode : {};
      let parentNode = document.getElementById(this.relativeNodeId);
      // return {width: parentNode.offsetWidth || 0, height: parentNode.offsetHeight || 0};

      let RectInfo = parentNode.getBoundingClientRect(); // 注意，使用getBoundingClientRect返回时若页面缩放，则返回的是缩放后的值
      RectInfo.realWidth = this.scaleToShow(RectInfo.width); // 真实宽
      RectInfo.realHeight = this.scaleToShow(RectInfo.height); // 真实高
      return RectInfo;
    },
    // 当前显示的，input宽高-当前组件宽高
    getCurrentInfo() {
      let dom = this.$refs["inputbox"];
      if (dom && dom.$el) {
        let { clientWidth, clientHeight } = dom.$el;
        let { x, y } = dom.$el.getBoundingClientRect();
        return {
          width: clientWidth,
          height: clientHeight,
          scaleWidth: this.scaleToVal(parseInt(clientWidth)) + "px",
          scaleHeight: this.scaleToVal(parseInt(clientHeight)) + "px",
          x, // 距离屏幕左侧距离
          y
        };
      } else
        return {
          width: 0,
          height: 0,
          scaleWidth: 0,
          scaleHeight: 0,
          x: 0, // 距离屏幕左侧距离
          y: 0
        };
    },
    /** 设置窗口复制按钮功能 */
    copyShowSetting(){
      this.$emit("quoteCopy", { ...this.itemInfo, showSetting: false});
    },
    // 输入框对应的设置弹窗显示更改
    changeShowSetting(val) {
      this.showSetting = !!val;
      console.log('showSetting',this.showSetting);
      this.$emit("changeItemInfo", { ...this.itemInfo, showSetting: !!val });
    },
    // 填写值改变
    changeValue(val) {
      // console.log(this.itemInfo,val, 444);
      this.$emit("changeItemInfo", { ...this.itemInfo, value: val });
    },
    /** 变量名称改变 */
    changeInputId(val){
      this.$emit("changeItemInfo", { ...this.itemInfo, inputId: val });
    },
    changechoce(val) {
      let {
        realWidth: parentWidth,
        realHeight: ParentHeight
      } = this.getParentInfo();
      let { height: newH } = this.flagType.getWHbyFont({...this.itemInfo});
      const _h=(parseFloat((parseInt(newH) / ParentHeight).toFixed(4))) * this.optionList.length
      this.$emit("changeItemInfo", { ...this.itemInfo, defineValue: val,h: _h}) // 新的高度比例值 });
    },
    // 提示文字改变
    changeVarName(val) {
      console.log('val',val);
      this.$emit("changeItemInfo", { ...this.itemInfo, varName: val });
    },
    /** 变量类型改变 */
    changeVarType(val){
      this.$emit("changeItemInfo", { ...this.itemInfo, varType: val });
    },
    // 字号改变-保存宽度不变，高度和字数变化
    changeFontSize(val) {
      let {
        realWidth: parentWidth,
        realHeight: ParentHeight
      } = this.getParentInfo();
      let { width, height } = this.getCurrentInfo();
      let fontSize = val;
      let fontMaxNum = this.flagType.getFontNumByWH(
        { ...this.itemInfo, fontSize },
        width
      );
      let { height: newHeight } = this.flagType.getWHbyFont({
        ...this.itemInfo,
        fontSize,
        fontMaxNum
      });
      this.$emit("changeItemInfo", {
        ...this.itemInfo,
        fontSize: val, // 新的fontsize
        fontMaxNum, // 新的字数
        h: +parseFloat((parseInt(newHeight) / ParentHeight).toFixed(4)) // 新的高度比例值
      });
    },
    /** 调用父组件更新组件属性值 */
    handleItemInfo(newInfo){
      this.$emit("changeItemInfo", newInfo);
    },
    // 删除当前项
    delItemInfo() {
      this.$emit("delItemInfo", this.itemInfo);
    },
    // 页面缩放后的值重新计算为页面真正的值
    scaleToShow(val) {
      return parseFloat(val) / (this.scaleValue / 100);
    },
    // 页面缩放-真实值计算为缩放后的值
    scaleToVal(val) {
      return parseFloat(val) * (this.scaleValue / 100);
    },
    // 签章停止事件
    handleCacheStop: function(el) {
      // if (this.chapteFixed) return
      el.preventDefault();
      this.doCachetStop(el);
    },
    // 签章鼠标按下事件
    handleCacheMousedown: function(el) {
      if (this.itemInfo.chapteFixed) return;
      el.preventDefault();
      this.doCachetStart();
      this.objCurrentCachet = el.target; // 获取move dom
      if (!this.objCurrentCachet) return;
      document.addEventListener("mousemove", this.handleCacheMousemove, false);
      document.addEventListener("mouseup", this.handleCacheStop, false);
    },
    // 签章随着鼠标移动事件--统一使用缩放值计算
    handleCacheMousemove: function(el) {
      // if (this.chapteFixed) return
      el.preventDefault();
      if (!this.cachetMove && !this.objCurrentCachet) return;
      let moveDom = this.$refs["move-box"];
      let {
        top: contBoxTop,
        left: contBoxLeft,
        width: contBoxW,
        height: contBoxH
      } = this.getParentInfo();
      let { pageX: mouseX, pageY: mouseY } = el;
      let {
        width: caechetW,
        height: caechetH
      } = moveDom.getBoundingClientRect();
      let top = mouseY - contBoxTop + this.scaleToVal(12); // 计算文本框距离合同顶部距离-12为拖拽点偏移值
      let left = mouseX - contBoxLeft - caechetW / 2;

      // 处理边界情况
      let boundaryValue = this.scaleToVal(35); // 合同的最小边界值
      if (top < boundaryValue) {
        top = boundaryValue;
      } else if (top > contBoxH - caechetH - boundaryValue) {
        top = contBoxH - caechetH - boundaryValue;
      }

      if (left < boundaryValue) {
        left = boundaryValue;
      } else if (left > contBoxW - caechetW - boundaryValue) {
        left = contBoxW - caechetW - boundaryValue;
      }

      // 加入缩放因子
      // console.log('加入缩放因子前的值',left,top)
      left = this.scaleToShow(left);
      top = this.scaleToShow(top);
      // console.log('加入缩放因子后的值',left,top)
      moveDom.style.top = `${top}px`;
      moveDom.style.left = `${left}px`;
    },

    // 签章停止移动-使用真实值计算
    doCachetStop: function(el) {
      this.cachetMove = false;
      // this.currentIndex = null
      document.removeEventListener(
        "mousemove",
        this.handleCacheMousemove,
        false
      );
      document.removeEventListener("mouseup", this.handleCacheStop, false);
      if (this.objCurrentCachet) {
        let moveDom = this.$refs["move-box"];
        let {
          realWidth: contBoxW,
          realHeight: contBoxH
        } = this.getParentInfo();
        let y = 0;
        if (moveDom) {
          y = moveDom.height || moveDom.clientHeight || moveDom.naturalHeight;
        }
        // console.log('left:', moveDom.style.left, 'top:', moveDom.style.top);
        this.$emit("changeItemInfo", {
          ...this.itemInfo,
          offsetX: +parseFloat(
            (parseInt(moveDom.style.left) / contBoxW).toFixed(5)
          ),
          offsetY: +parseFloat(
            ((parseInt(moveDom.style.top) + y) / contBoxH).toFixed(5)
          )
        });
        this.objCurrentCachet = null;
      }
    },
    // 签章移动开始
    doCachetStart: function() {
      this.cachetMove = true;
    },
    // 。。。。。。。。。。。。缩放文本框 start。。。。。。。。。。。
    // 宽高更改，字体大小不变，字数变化
    sfMousedownHanlder(el, dataType) {
      let _self = this;
      let mDownEvent = el;
      let {
        scaleWidth,
        scaleHeight,
        x: inputX,
        y: inputY
      } = this.getCurrentInfo();
      scaleWidth = parseInt(scaleWidth);
      scaleHeight = parseInt(scaleHeight);

      let mousemoveHandler = function(moveEvent) {
        // 参数为输入框的一些信息
        _self[dataType]({
          mDownEvent,
          moveEvent,
          scaleWidth,
          scaleHeight,
          inputX,
          inputY
        });
      };

      let sfMouseup = function() {
        mDownEvent = null;
        document.removeEventListener("mousemove", mousemoveHandler, false);
        document.removeEventListener("mouseup", sfMouseup, false);
      };
      document.addEventListener("mousemove", mousemoveHandler, false);
      document.addEventListener("mouseup", sfMouseup, false);
    },
    // 右侧点向右拉伸宽度-计算过程中使用缩放值
    r_getNewWidth({
      mDownEvent,
      moveEvent,
      scaleWidth,
      scaleHeight,
      inputX,
      inputY
    }) {
      let {
        x: x,
        width: scaleParentWidth,
        realWidth: parentWidth,
        realHeight: ParentHeight
      } = this.getParentInfo();
      let newWidth = 0;
      if (moveEvent.x > mDownEvent.x) {
        // 合同宽度-input框右侧到合同左侧距离-右侧边界35 + 输入框宽度 = 输入框最大宽度
        let maxWidth =
          scaleParentWidth -
          (inputX - x + scaleWidth) -
          this.scaleToVal(35) +
          scaleWidth;
        newWidth = scaleWidth + (moveEvent.x - mDownEvent.x);
        newWidth = Math.min(maxWidth, newWidth); // 最大展开到右侧合同边界（边界值：当前系统统一 35px ）
      } else {
        newWidth = scaleWidth - (mDownEvent.x - moveEvent.x);
        let { minWidth } = this.flagType.minMaxFontInfo(this.itemInfo);
        newWidth = Math.max(this.scaleToVal(minWidth), newWidth); // 最小显示一个字宽度
      }

      newWidth = this.scaleToShow(newWidth);
      return newWidth;
    },
    // 左侧点向左拉伸宽度-计算过程中使用缩放值
    l_getNewWidth({
      mDownEvent,
      moveEvent,
      scaleWidth,
      scaleHeight,
      inputX,
      inputY
    }) {
      let {
        x: x,
        width: scaleParentWidth,
        realWidth: parentWidth,
        realHeight: ParentHeight
      } = this.getParentInfo();
      let newWidth = 0;
      if (moveEvent.x < mDownEvent.x) {
        // 输入框向左扩大
        // input框左侧到合同左侧距离+输入框宽度-左侧边界35  = 输入框最大宽度
        let maxWidth = inputX - x + scaleWidth - this.scaleToVal(35);
        newWidth = scaleWidth + (mDownEvent.x - moveEvent.x);
        newWidth = Math.min(maxWidth, newWidth); // 最大展开到左侧合同边界（边界值：当前系统统一 35px ）
      } else {
        newWidth = scaleWidth - (moveEvent.x - mDownEvent.x);
        let { minWidth } = this.flagType.minMaxFontInfo(this.itemInfo);
        newWidth = Math.max(this.scaleToVal(minWidth), newWidth); // 最小显示一个字宽度
      }

      newWidth = this.scaleToShow(newWidth);
      return newWidth;
    },
    // 底部点向下拉伸高度-计算过程中使用缩放值
    b_getNewHeight({
      mDownEvent,
      moveEvent,
      scaleWidth,
      scaleHeight,
      inputX,
      inputY
    }) {
      let {
        y: y,
        width: scaleParentWidth,
        height: scaleParentHeight,
        realWidth: parentWidth,
        realHeight: ParentHeight
      } = this.getParentInfo();
      let newHeight = 0;
      if (moveEvent.y > mDownEvent.y) {
        // 合同高度-input框底部到合同底部距离-边界35 + 输入框高度 = 输入框最大高度
        let maxHeight =
          scaleParentHeight -
          (inputY - y + scaleHeight) -
          this.scaleToVal(35) +
          scaleHeight;
        newHeight = scaleHeight + (moveEvent.y - mDownEvent.y);
        newHeight = Math.min(maxHeight, newHeight); // 最大展开到合同底部边界（边界值：当前系统统一 35px ）
      } else {
        newHeight = scaleHeight - (mDownEvent.y - moveEvent.y);
        let { minHeight } = this.flagType.minMaxFontInfo(this.itemInfo);
        newHeight = Math.max(this.scaleToVal(minHeight), newHeight); // 最小显示一个字高度
      }
      newHeight = this.scaleToShow(newHeight);
      return newHeight;
    },
    // 顶部点向上拉伸高度-计算过程中使用缩放值
    t_getNewHeight({
      mDownEvent,
      moveEvent,
      scaleWidth,
      scaleHeight,
      inputX,
      inputY
    }) {
      let {
        y: y,
        width: scaleParentWidth,
        height: scaleParentHeight,
        realWidth: parentWidth,
        realHeight: ParentHeight
      } = this.getParentInfo();
      let newHeight = 0;
      if (moveEvent.y < mDownEvent.y) {
        // 输入框距离合同顶部距离+输入框高度-边界值 = 输入框最大高度
        let maxHeight = inputY - y + scaleHeight - this.scaleToVal(35);
        newHeight = scaleHeight + (mDownEvent.y - moveEvent.y);
        newHeight = Math.min(maxHeight, newHeight); // 最大展开到合同顶部边界（边界值：当前系统统一 35px ）
      } else {
        newHeight = scaleHeight - (moveEvent.y - mDownEvent.y);
        let { minHeight } = this.flagType.minMaxFontInfo(this.itemInfo);
        newHeight = Math.max(this.scaleToVal(minHeight), newHeight); // 最小显示一个字高度
      }
      newHeight = this.scaleToShow(newHeight);
      return newHeight;
    },
    // 右侧点向右拉伸宽度-计算过程中使用缩放值
    r(obj) {
      let {
        x: x,
        width: scaleParentWidth,
        realWidth: parentWidth,
        realHeight: ParentHeight
      } = this.getParentInfo();
      let newWidth = this.r_getNewWidth(obj);
      this.$emit("changeItemInfo", {
        ...this.itemInfo,
        w: +parseFloat(newWidth / parentWidth).toFixed(4),
        fontMaxNum: this.flagType.getFontNumByWH(
          this.itemInfo,
          newWidth,
          ParentHeight * this.itemInfo.h
        )
      });
    },
    // 右下侧点拉伸宽度-计算过程中使用缩放值
    br(obj) {
      let {
        x: x,
        width: scaleParentWidth,
        realWidth: parentWidth,
        realHeight: ParentHeight
      } = this.getParentInfo();
      let newWidth = this.r_getNewWidth(obj);
      let newHeight = this.b_getNewHeight(obj);

      this.$emit("changeItemInfo", {
        ...this.itemInfo,
        offsetY: +parseFloat(
          (
            (this.itemInfo.offsetY * ParentHeight -
              this.itemInfo.h * ParentHeight +
              newHeight) /
            ParentHeight
          ).toFixed(4)
        ),
        // 左下角的定位点位置随之变化
        h: +parseFloat(newHeight / ParentHeight).toFixed(4),
        w: +parseFloat(newWidth / parentWidth).toFixed(4),
        fontMaxNum: this.flagType.getFontNumByWH(
          this.itemInfo,
          newWidth,
          newHeight
        )
      });
    },
    // 右上侧点拉伸宽度-计算过程中使用缩放值
    tr(obj) {
      let {
        x: x,
        width: scaleParentWidth,
        realWidth: parentWidth,
        realHeight: ParentHeight
      } = this.getParentInfo();
      let newWidth = this.r_getNewWidth(obj);
      let newHeight = this.t_getNewHeight(obj);

      this.$emit("changeItemInfo", {
        ...this.itemInfo,
        // offsetY: this.itemInfo.offsetY, // 左下角的定位点位置随之变化
        h: +parseFloat(newHeight / ParentHeight).toFixed(4),
        w: +parseFloat(newWidth / parentWidth).toFixed(4),
        fontMaxNum: this.flagType.getFontNumByWH(
          this.itemInfo,
          newWidth,
          newHeight
        )
      });
    },
    // 左上侧点拉伸宽度-计算过程中使用缩放值
    tl(obj) {
      let {
        x: x,
        width: scaleParentWidth,
        realWidth: parentWidth,
        realHeight: ParentHeight
      } = this.getParentInfo();
      let newWidth = this.l_getNewWidth(obj);
      let newHeight = this.t_getNewHeight(obj);

      this.$emit("changeItemInfo", {
        ...this.itemInfo,
        offsetX: +parseFloat(
          (
            (this.itemInfo.offsetX * parentWidth +
              this.itemInfo.w * parentWidth -
              newWidth) /
            parentWidth
          ).toFixed(4)
        ),
        h: +parseFloat(newHeight / ParentHeight).toFixed(4),
        w: +parseFloat(newWidth / parentWidth).toFixed(4),
        fontMaxNum: this.flagType.getFontNumByWH(
          this.itemInfo,
          newWidth,
          newHeight
        )
      });
    },
    // 左下侧点拉伸宽度-计算过程中使用缩放值
    bl(obj) {
      let {
        x: x,
        width: scaleParentWidth,
        realWidth: parentWidth,
        realHeight: ParentHeight
      } = this.getParentInfo();
      let newWidth = this.l_getNewWidth(obj);
      let newHeight = this.b_getNewHeight(obj);

      this.$emit("changeItemInfo", {
        ...this.itemInfo,
        offsetY: +parseFloat(
          (
            (this.itemInfo.offsetY * ParentHeight -
              this.itemInfo.h * ParentHeight +
              newHeight) /
            ParentHeight
          ).toFixed(4)
        ),
        offsetX: +parseFloat(
          (
            (this.itemInfo.offsetX * parentWidth +
              this.itemInfo.w * parentWidth -
              newWidth) /
            parentWidth
          ).toFixed(4)
        ),
        h: +parseFloat(newHeight / ParentHeight).toFixed(4),
        w: +parseFloat(newWidth / parentWidth).toFixed(4),
        fontMaxNum: this.flagType.getFontNumByWH(
          this.itemInfo,
          newWidth,
          newHeight
        )
      });
    }
    // 。。。。。。。。。。。。缩放文本框 end。。。。。。。。。。。。
  },
  watch:{
    'itemInfo.defineValue':{
      handler(newVal, oldVal) {
        this.turnOptions()
      },
      deep:true,
      immediate:true
    },
  }
};
</script>
<style lang="less" scoped>
@ebq-red:#ec1c1c;
@input-pink:#fef3f3;
@var-gary:#b1b1b1;
@icon-size:var(--icon-size);
@size-half:calc(@icon-size / 2);
.check-icon{
  .size-set{
    width: @icon-size;
    height: @icon-size;
    margin-left: @size-half;
  }
  .p-left{
    padding-left: @size-half;
  }
  /deep/ .el-radio__inner{
    .size-set()
  }
  /deep/ .el-radio__inner::after{
    width: @size-half;
    height: @size-half;
  }
  /deep/ .el-radio__label{
    .p-left()
  }
  /deep/ .el-checkbox__inner{
    .size-set()
  }
  /deep/ .el-checkbox__inner::after{
    width: @size-half;
    height: @size-half;
  }
  /deep/ .el-checkbox__label{
    .p-left()
  }
}
.copy-sty{
  background: #f4ffb8 !important;
  border: 1px solid #7cb305 !important;
}
.text_align_center {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner {
    text-align: center;
  }
}
.text_align_right {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner {
    text-align: right;
  }
}
.font_bold {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner {
    font-weight: bold;
  }
}
.copy-sty-input{
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner {
    .copy-sty();
  }
}
.item-check{
  // margin-bottom: 5px;
  text-align: left;
}
.let-name{
  color:@var-gary;
  text-align: left;
}
.check-sty{
  // padding: 5px;
  background: @input-pink;
  border: 1px solid @ebq-red;
  line-height: 0;
  >p{
    margin-bottom: 0 !important;
    text-align: left;
  }
  /deep/ .el-checkbox__label{
    line-height: inherit;
  }
}
.option-item{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}
.action-sty{
  cursor: pointer;
  &:hover{
    color: @ebq-red;
  }
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: center;
  >i{
    font-weight: 600;
    cursor: pointer;
  }
}
.var-setting{
  margin:15px 0 5px 0;
}
/deep/ input[type="number"] {
  -moz-appearance: textfield;
}

/deep/ input[type="number"]::-webkit-inner-spin-button,
/deep/ input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.widgets-wrap {
  position: absolute;
  z-index: 10;
  outline: none;

  &:focus {
    outline: none;
  }

  &.move {
    z-index: 30;
  }

  &.fixed {
    cursor: default !important;
  }

  // 置于最顶层
  &.maxTop {
    z-index: 666;
  }
}

// 文本框公共样式
.font-css {
  letter-spacing: 2.44px;
  /*font-family: 宋体;*/
  font-family: SimSun; // 宋体
}

// 自由组件样式
.input-wrap {
  position: relative;

  .icon-drag {
    position: absolute;
    width: 13px;
    height: 13px;
    top: -18px;
    left: 50%;
    margin-left: -6px;
    cursor: move;
    display: inline-block;
    background: url("/images/advancedVersion/drag.png") no-repeat center center;
    background-size: 100% 100%;
    z-index: 8;
  }

  .delco {
    cursor: pointer;
    font-size: 16px;
    position: absolute;
    top: -21px;
    right: -12px;
    color: #ec1c1c;
    z-index: 8;
  }

  // 输入框样式
  .inputCss() {
    background: #fef3f3;
    border: 1px solid #ec1c1c;
    opacity: 1;
    border-radius: 2px;
    height: 100%;
    line-height: initial;
    /*padding: 5px 5px;*/
    padding: 0;
    box-sizing: border-box;
    display: block;
    letter-spacing: 0;
    .font-css();
  }

  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner {
    .inputCss();
  }

  /*element ui textarea 样式在当前功能显示有问题，这里重置*/

  /deep/ .el-textarea__inner {
    position: absolute;
    left: 0;
    top: 0;
    width: 100% !important;
    height: 100% !important;
    min-height: auto !important;
    overflow: hidden;
  }

  /deep/ .el-textarea {
    display: block;
  }

  /*日期*/
  /deep/ .el-date-editor {
    .el-input__inner {
      .inputCss();
    }
    .el-input__prefix,
    .el-input__suffix {
      display: none;
    }
  }
}

// 设置弹窗
.set-wrap {
  position: absolute;
  /*top: 0;*/
  /*right: -195px;*/
  width: 190px;
  background: #ffffff;
  border: 1px solid #dcdcdc;
  opacity: 1;
  border-radius: 2px;
  text-align: left;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #290202;

  .el-icon-error {
    font-size: 16px;
    cursor: pointer;
    color: #a1a1a1;
  }

  h1 {
    width: 100%;
    height: 29px;
    background: #f8f8f8;
    border-radius: 2px 2px 0px 0px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #290202;
    padding-left: 9px;
    padding-right: 3px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
  }

  .con {
    padding: 0 10px;
    box-sizing: border-box;

    /deep/ .el-input__inner,
    /deep/ .el-textarea__inner {
      background: #ffffff;
      border: 1px solid #dcdcdc;
      opacity: 1;
      border-radius: 2px;
      height: 25px;
      line-height: 25px;
      padding: 0 5px;
    }

    /deep/ .el-textarea__inner {
      height: auto;
      /*line-height: 15px;*/
    }

    /deep/ .el-select {
      width: 100%;
    }

    /deep/ .el-input__icon {
      line-height: 25px;
    }

    /deep/ .el-checkbox {
      color: #290202;
    }

    /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #ec1c1c;
    }
  }
  .btns-sty{
    display: flex;
    .btn:first-child{
      border-right: 1px solid #d9d9d9;
    }
    .btn {
      cursor: pointer;
      text-decoration: none;
      width: 100%;
      height: 29px;
      line-height: 29px;
      background: #f8f8f8;
      opacity: 1;
      border-radius: 0px 0px 2px 2px;
      text-align: center;
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #290202;
      display: block;
      margin-top: 16px;
    }
  }

}

// 固定组件样式
.fixedWt {
  position: relative;

  // 输入框样式
  .inputCss() {
    opacity: 1;
    border-radius: 2px;
    height: 100%;
    line-height: initial;
    /*padding: 5px 5px;*/
    padding: 0;
    box-sizing: border-box;
    display: block;
    letter-spacing: 0;
    background: #feeded;
    border: 1px solid #fecdcd;
    color: #290202;
    .font-css();
  }

  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner {
    .inputCss();
  }

  /*element ui textarea 样式在当前功能显示有问题，这里重置*/

  /deep/ .el-textarea__inner {
    position: absolute;
    left: 0;
    top: 0;
    width: 100% !important;
    height: 100% !important;
    min-height: auto !important;
    overflow: hidden;
  }

  /deep/ .el-textarea {
    display: block;
  }

  /*日期*/
  /deep/ .el-date-editor {
    .el-input__inner {
      .inputCss();
    }
    .el-input__prefix,
    .el-input__suffix {
      display: none;
    }
  }
  .outstanding {
    /deep/ .el-input__inner,
    /deep/ .el-textarea__inner {
      background: #f1c7c7;
      border: 1px solid #ec1c1c;
    }
    /*日期*/
    /deep/ .el-date-editor {
      .el-input__inner {
        background: #f1c7c7;
        border: 1px solid #ec1c1c;
      }
    }
  }
}

/*拉伸点位*/
.dian {
  display: block;
  position: absolute;
  width: 4px;
  height: 4px;
  background: #ffffff;
  border: 1px solid #ec1c1c;
  opacity: 1;
  border-radius: 2px;
  z-index: 5;
}

.r {
  .dian();
  top: 50%;
  margin-top: -2px;
  right: -2px;
  cursor: w-resize;
}

.br {
  .dian();
  bottom: -2px;
  right: -2px;
  cursor: se-resize;
}

.tr {
  .dian();
  top: -2px;
  right: -2px;
  cursor: ne-resize;
}

.tl {
  .dian();
  left: -2px;
  top: -2px;
  cursor: se-resize;
}

.bl {
  .dian();
  left: -2px;
  bottom: -2px;
  cursor: ne-resize;
}
</style>



// WEBPACK FOOTER //
// components/advancedVersion/widgets.vue